import { actionsCreator } from "../utils/Actions"
import ActionCreator from "../utils/ActionCreator"

const { set } = new ActionCreator("queue")

const { actions } = actionsCreator("queue")
export { actions as appActions }

export const setQueueData = set("QUEUE_REQUEST")
export const setQueueRemoveData = set("REMOVE_QUEUE")
export const setClearQueue = set("CLEAR_QUEUE")
